<script>
import { formatNumber } from "../../helpers/formatting";

export default {
  name: "Card",
  props: {
    title: String,
    icon: {
      default: "dashboard",
    },
    total: {
      type: Number,
      required: false,
    },
  },
  methods: {
    formatNumber,
  },
};
</script>

<template>
  <div class="rounded-xl w-full h-48 text-white bg-primary">
    <div
      class="flex flex-row justify-between mx-16 !text-2xl items-center gap-2 h-full font-semibold antialiased"
    >
      <div class="flex flex-col gap-4 text-right">
        <inline-svg
          v-if="icon == 'dashboard'"
          class="icono-dashboard"
          src="../../assets/images/containersdashboard.svg"
          title="Despachos"
        />
        <fas v-else size="2x" :icon="['fas', icon]" />

        <span>
          {{ title ?? "Total despachos" }}
        </span>
      </div>
      <div class="flex flex-col gap-4">
        {{ formatNumber(total) ?? "-" }}
      </div>
    </div>
  </div>
</template>
